import React from "react";
import eventImage from "assets/images/common/others/exploreEvents.png";
import HostImage from "assets/images/common/others/attende1.png";
import { ReactComponent as ReviewGolden } from "assets/images/common/svgs/reviewGolden.svg";
import eventBadge from "assets/images/common/others/eventBadge.png";
import dummyImage from "assets/images/common/others/minorImage.png";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  eventData: any;
}

const EventDetail = ({ eventData }: Props) => {
  return (
    <div className="w-full lg:w-[750px]">
      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Learning Activity
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.description || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Core Concepts
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.coreConcept
              ?.map((concept: any) =>
                concept
                  .toLowerCase()
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char: any) => char.toUpperCase())
              )
              .join(", ")}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Parent Supervision
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.parentSupervision === true
              ? "Yes"
              : eventData?.event?.parentSupervision === false
                ? "No"
                : "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Special Instructions
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.specialInstructions || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4 max-w-60">
          <span className="text-sm font-semibold text-captionText">
            Physical Consideration
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.physicalConsideration || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4 ">
          <span className="text-sm font-semibold text-captionText">
            Digital Badge
          </span>
          <span className="">
            <img
              className="w-[60px] h-[60px] "
              // src={eventBadge}
              src={
                eventData?.event?.badge
                  ? concatPathWithBackendUrl(
                    eventData?.event?.badge?.fileDownloadUri
                  )
                  : ""
              }
              alt="eventBadge"
            />
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            {eventData?.rsvp ? "RSVP" : "Host"}
          </span>
          <span className="flex gap-3 items-center">
            <img
              className="w-10 h-10 rounded-full"
              src={
                eventData?.rsvp?.profilePicUrl?.fileDownloadUri
                  ? concatPathWithBackendUrl(eventData.rsvp.profilePicUrl.fileDownloadUri)
                  : eventData?.host?.profilePicUrl?.fileDownloadUri
                    ? concatPathWithBackendUrl(eventData.host.profilePicUrl.fileDownloadUri)
                    : editProfilePicUser
              }
              alt="Image"
            />
            <p className="text-base font-bold text-primaryText">
              {(eventData?.rsvp?.firstName || eventData?.host?.firstName || "-") + " " +
                (eventData?.rsvp?.lastName || eventData?.host?.lastName || "")}
            </p>
          </span>
        </div>

      </div>


    </div>
  );
};

export default EventDetail;
